module.exports = __webpack_public_path__ + "../resources/img/ic_search_cancel.50c7b712.svg";